module.exports = __webpack_public_path__ + "img/youtube.4b121ede.svg";